<div style="overflow-x:auto;height: 450px;">
    <table>
        <thead>
            <tr>
              
                <th *ngIf="selectedTab!='completed' && selectedTab!='skipped'">
                    <ng-container>
                        <mat-checkbox [attr.guide]="'task-table-chk-1' + '__' + sanitizedUrl" *ngIf="showEditPopup"
                            (change)="toggleAllRows($event.checked)" [checked]="isAllSelected()"
                            [indeterminate]="selection.hasValue() && !isAllSelected()"
                            [aria-label]="checkboxLabel()"></mat-checkbox>
                    </ng-container>
                </th>

                <th class="th-task">Task</th>

                <ng-container *ngIf="type==2">

                    <th class="th-scheduled">
                        <ng-container *ngIf="type==2">Scheduled Date</ng-container>
                    </th>
                    <th>
                        <ng-container *ngIf="type==2">Task Type</ng-container>
                    </th>
                </ng-container>
                <!-- Always render these header cells so columns stay aligned; show content only for type==2 -->

                <th>Task Priority</th>
                <th>Opens, Clicks, Replies</th>
                <th>Task Type</th>
                <ng-container *ngIf="type==2">
                    <th>Subject/Notes</th>
                </ng-container>
                <th>Due Date</th>
                <ng-container *ngIf="type==2">
                    <th>Completed Date</th>
                    <th>Task Status</th>
                    <th>Failed Reason</th>
                </ng-container>
                <ng-container *ngIf="showFailureReason">
                    <th>Failed Reason</th>

                </ng-container>
                <th>Owner</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let task of filteredTasks; let i = index">

                <td *ngIf="selectedTab!='completed' && selectedTab!='skipped'">
                    <ng-container>
                        <mat-checkbox [attr.guide]="'task-table-chk-2' + '__' + sanitizedUrl" *ngIf="showEditPopup"
                            (change)="toggleRow(task)" [checked]="selection.isSelected(task)">
                        </mat-checkbox>
                    </ng-container>
                </td>

                <td>
                    <div style="display:flex;align-items:center;gap:12px;">
                        <mat-icon
                            style="color:#e76a6a;border: 1px solid #e76a6a;border-radius: 15px;padding: 2px; font-size:17px; height:27px; width:27px; display:flex; align-items:center; justify-content:center;">
                            {{ task.type === "1" ? 'mail_outline' : task.type === "2" ? 'call' : task.type === "3" ?
                            'work' : task.type === "4" ? 'chat' : task.type === "5" ? 'sms' : task.type === "6" ? 'task'
                            : 'help_outline' }}</mat-icon>
                        <div>
                            <div [attr.guide]="'task-table-row-' + i + '__' + sanitizedUrl"
                                (click)="(task.skipped == 1 || selectedTab == 'skipped') ? null : ((task.type === '2' && (webMobileCallEnable == 1 || dialerType != 4)) ? phoneNumbercall(task) : togglePanel(task))"
                                [style.cursor]="(task.skipped == 1 || selectedTab == 'skipped') ? 'default' : 'pointer'"
                                style="font-weight:700;color:#23333b;">{{ task.firstName || 'No Name' }}
                            </div>
                            <div style="font-size:12px;color:#8b99a8;margin-top:6px;">@ {{ task.jobTitle }} • {{
                                task.dueDate | calsoftDate }}</div>
                        </div>
                    </div>
                </td>

                <ng-container *ngIf="type==2">
                    <td><ng-container *ngIf="type==2">{{ task.scheduledDate | calsoftDate }}</ng-container></td>
                    <td><ng-container *ngIf="type==2">{{ task.actionType }}</ng-container></td>
                    <!-- Scheduled Date and Action Type cells kept always so columns align; content shown only for type==2 -->
                </ng-container>
                <td>
                    <span style="background:#e8f2ff;color:#0b5cff;padding:6px 10px;border-radius:6px;font-weight:600;">
                        {{ task.priority === 0 ? 'Low' : task.priority === 1 ? 'Low' : task.priority === 2 ? 'Normal' :
                        task.priority === 3 ? 'High' : task.priority === 4 ? 'Critical' : '' }}
                    </span>
                </td>

                <td>
                    <div style="display:flex;align-items:center;gap:18px;justify-content:flex-start;">
                        <div style="display:flex;align-items:center;gap:6px;">
                            <mat-icon style="font-size:18px;" [matBadge]="task.openedCount ?? 0" matBadgeSize="small"
                                matBadgeOverlap="false">visibility</mat-icon>
                        </div>

                        <div style="display:flex;align-items:center;gap:6px;">
                            <mat-icon style="font-size:18px;" [matBadge]="task.linkClickedCount ?? 0"
                                matBadgeSize="small" matBadgeOverlap="false">mouse</mat-icon>
                        </div>

                        <div style="display:flex;align-items:center;gap:6px;">
                            <mat-icon style="font-size:18px;" [matBadge]="task.replyCount ?? 0" matBadgeSize="small"
                                matBadgeOverlap="false">reply</mat-icon>
                        </div>
                    </div>
                </td>

                <td>{{ task.type === "1" ? 'Email' : task.type === "2" ? 'Call' : task.type === "3" ? 'LinkedIn' :
                    task.type === "4" ? 'Whatsapp' : task.type === "5" ? 'Sms' : task.type === "6" ? 'Task' : 'None' }}
                    task for <a style="color:#2f6fb8;font-weight:600;">{{task.taskStep}} of {{task.sequenceName}}</a>
                </td>


                <ng-container *ngIf="type==2">
                    <td>
                        <span *ngIf="task.type ==1">

                            <div [innerHTML]="task.subject ? (task.subject) : ''">


                            </div>

                        </span>

                        <span *ngIf="task.type !=1">


                            <div [innerHTML]="task.stepNotes ? (task.stepNotes) : ''">


                            </div>


                        </span>

                    </td>
                </ng-container>
                <td>
                    <span class="due-pill"
                        [ngClass]="{'due-red': isPastOrToday(task.dueDate),'due-green': !isPastOrToday(task.dueDate)}">{{
                        task.dueDate | calsoftDate }}</span>
                </td>
                <ng-container *ngIf="type==2">
                    <td><ng-container *ngIf="type==2">{{ task.completedDate | calsoftDate }}</ng-container></td>
                    <td><ng-container *ngIf="type==2">{{ task.completedStatus }}</ng-container></td>
                    <td><ng-container *ngIf="type==2">{{ task.failedMessage }}</ng-container></td>
                </ng-container>
                <ng-container *ngIf="showFailureReason">
                    <td><ng-container *ngIf="showFailureReason">{{ task.failedMessage }}</ng-container></td>
                </ng-container>
                <td>
                    <div style="display:flex;align-items:center;gap:8px;">
                        <div
                            style="width:34px;height:34px;border-radius:50%;background:#f2f6f8;color:#22333c;display:flex;align-items:center;justify-content:center;font-weight:700;padding: 10px;">
                            {{ ((task.userName ?? '') + '').split('@')[0] | slice:0:2 | titlecase }}</div>
                    </div>
                </td>

                <td>
                    <ng-container *ngIf="showEditPopup">
                        <button [attr.guide]="'task-table-btn-more' + '__' + sanitizedUrl"
                            *ngIf="(task.currentTask==1 &&task.skipped==0 &&task.failed!=1 )  && (task.completed==0)"
                            mat-icon-button [matMenuTriggerFor]="actionsMenu"
                            aria-label="more"><mat-icon>more_vert</mat-icon></button>

                        <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
                            <!-- Show Edit only when task is current and not completed. Handle both camelCase and snake_case and falsy values -->
                            <button [attr.guide]="'task-table-btn-3' + '__' + sanitizedUrl"
                                (click)="toglePanelEdit(task)" mat-menu-item>
                                <mat-icon>edit</mat-icon>
                                <span>Edit</span>
                            </button>

                            <button [attr.guide]="'task-table-btn-4' + '__' + sanitizedUrl" (click)="skipSteps(task)"
                                mat-menu-item>
                                <mat-icon>skip_next</mat-icon>
                                <span>Skip Task</span>
                            </button>

                            <button [attr.guide]="'task-table-btn-5' + '__' + sanitizedUrl"
                                (click)="removeForSequence(task)" mat-menu-item>
                                <mat-icon>delete</mat-icon>
                                <span>Remove From Sequence</span>
                            </button>

                        </mat-menu>
                    </ng-container>
                </td>
            </tr>
        </tbody>
    </table>


</div>

<div class="popup" *ngIf="isFilterPanelOpen" (click)="$event.stopPropagation()">
    <calsoft-task-popup [task]="selectedTask" [type]="selectedTask.type"
        (closePopup)="closePopupNew($event)"></calsoft-task-popup>
</div>